import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@epoch-ui/lib/utils';

export const badgeVariants = cva(
  'tw-inline-flex tw-gap-[2px] tw-items-center tw-rounded-[8px] tw-border tw-border-border tw-border-solid tw-px-[6px] tw-py-[3px] tw-text-xs tw-font-semibold tw-transition-colors focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-ring focus:tw-ring-offset-2',
  {
    variants: {
      variant: {
        primary: 'tw-border-transparent tw-bg-brand-tertiary tw-text-brand-primary',
        secondary: 'tw-border-transparent tw-bg-secondary tw-text-secondary-foreground',
        positive: 'tw-border-transparent tw-bg-positive tw-text-positive-foreground',
        warning: 'tw-border-transparent tw-bg-warning tw-text-warning-foreground',
        destructive: 'tw-border-transparent tw-bg-destructive tw-text-destructive-foreground',
        purple: 'tw-border-transparent tw-bg-accent-purple-light tw-text-accent-purple',
        outline: 'tw-text-muted-foreground'
      },
      size: {
        sm: 'tw-text-xs tw-font-medium tw-leading-4 tw-px-[6px] tw-py-[3px]',
        md: 'tw-text-xs tw-font-medium tw-leading-4 tw-px-2 tw-py-[6px] tw-gap-1',
        lg: 'tw-text-sm tw-font-normal tw-leading-5 tw-px-2 tw-py-[6px] tw-gap-1'
      }
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md'
    }
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

export const Badge = ({ className, variant, size, ...props }: BadgeProps): JSX.Element => {
  return <div className={cn(badgeVariants({ variant, size }), className)} {...props} />;
};
